import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { PrimaryButton } from "@/components/brand/PrimaryButton";
import { SecondaryButton } from "@/components/brand/SecondaryButton";
import {
  ALLOW_ON_DOMAIN_BOOKING,
  APPROVED_CONSULT_URL,
  CONSULT_URL_IS_EXTERNAL,
  CONSULT_CTA_LABEL,
} from "@/config/compliance";

/**
 * The single consultation call to action.
 *
 * At `education_plus_onsite_consult` it points at the on-domain /book route.
 * Below that level it links OUT to the approved consultation destination and no
 * form is presented on this domain.
 */
export function ConsultCTA({
  variant = "primary",
  size = "lg",
  className,
  children,
  onNavigate,
}: {
  variant?: "primary" | "secondary";
  size?: "default" | "lg";
  className?: string;
  children?: ReactNode;
  onNavigate?: () => void;
}) {
  const Button = variant === "primary" ? PrimaryButton : SecondaryButton;
  const label = children ?? CONSULT_CTA_LABEL;

  return (
    <Button asChild size={size} className={className}>
      {ALLOW_ON_DOMAIN_BOOKING ? (
        <Link to="/book" onClick={onNavigate}>
          {label}
        </Link>
      ) : (
        <a
          href={APPROVED_CONSULT_URL}
          {...(CONSULT_URL_IS_EXTERNAL ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          onClick={onNavigate}
        >
          {label}
        </a>
      )}
    </Button>
  );
}
